import Constants from 'config/constants';

export class StoreHours {
	static getOpenTimes(input) {
		let keyNames = Object.keys(input);
		let today = new Date().getDay();
		let openDay = keyNames.find((day => day === keyNames[today]));
		let openHours = input[openDay];
		let times = openHours.split('-');

		return {
			openHour: parseInt(times[0].substring(0, 2).replace(/^0+/, '')),
			closeHour: parseInt(times[1].substring(0, 2).replace(/^0+/, '')),
			openMinutes: parseInt(times[0].substring(2, 4)),
			closeMinutes: parseInt(times[1].substring(2, 4))
		};
	}

	static verifyCheckInTypeNotAvailable(openStatus, checkInType) {
		return (openStatus !== Constants.STORE_STATUS_OPEN) && (openStatus !== checkInType);
	}

	static verifyOutsideOfStoreHours(currHour, openHour, closeHour, currMin, openMinutes, closeMinutes) {
		return !(((currHour > openHour) && (currHour < closeHour)) ||
			(((currHour === openHour && currMin >= openMinutes) || (currHour === closeHour && currMin < closeMinutes))));
	}
}
